module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions/right-table-14d7340e400ec7bdf24675ae925330fe.png";